import { ElementType } from 'react';
import { Assert } from '@team/assert';
import { TappableProps, TappableStateMode } from '../../services/tappable';
import { Mode, Size } from './enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.BEZELED]: css.bezeled,
  [Mode.PLAIN]: css.plain,
  [Mode.GRAY]: css.gray,
};

export const sizePresets: Record<Size, string> = {
  [Size.SMALL]: css.small,
  [Size.MEDIUM]: css.medium,
  [Size.LARGE]: css.large,
};

export const hoverModePresets: Record<Mode, TappableStateMode> = {
  [Mode.BEZELED]: TappableStateMode.BACKGROUND,
  [Mode.PLAIN]: TappableStateMode.BACKGROUND,
  [Mode.GRAY]: TappableStateMode.OPACITY,
};

export const activeModePresets: Record<Mode, TappableStateMode> = {
  [Mode.BEZELED]: TappableStateMode.BACKGROUND,
  [Mode.PLAIN]: TappableStateMode.BACKGROUND,
  [Mode.GRAY]: TappableStateMode.OPACITY,
};

/**
 * @todo повторяющаяся логика с Button
 */
export const detectComponent = ({ href }: TappableProps): ElementType =>
  Assert.isDefined(href) ? 'a' : 'button';
